import { Component, OnInit, ViewChild } from "@angular/core";
import { MainHubService } from "src/app/services/main-hub.service";
import * as moment from "moment";
import { formatDate } from "@angular/common";
import { ActivatedRoute } from "@angular/router";
import { ApiRestService } from "src/app/services/apirestservice.service";
import { ThrowStmt } from "@angular/compiler";
import { AmeritradePotentialTradesQuoteResponse } from "src/app/Models/AmeritradePotentialTradesQuoteResponse";
import { AmeritradeOptionQuoteResponse } from "src/app/Models/AmeritradeSymbolOptionsQuotesResponse";

@Component({
  selector: "app-possible-trades",
  templateUrl: "./possible-trades.component.html",
  styleUrls: ["./possible-trades.component.scss"],
})
export class PossibleTradesComponent implements OnInit {
  constructor(
    public mainHubService: MainHubService,
    private activeRoute: ActivatedRoute,
    private restService: ApiRestService
  ) {}

  public QuoteData;
  public QuoteDataOptions;
  public datefilter;
  public tradesFound;
  public dateNow;
  public underlying;
  public volatillity;
  public displayData = false;

  ngOnInit(): void {
    let symbol = this.activeRoute.snapshot.params.symbol;

    this.restService.getTrades(symbol).subscribe((v) => {
      this.QuoteData = v as AmeritradePotentialTradesQuoteResponse[];
      this.tradesFound = this.QuoteData.length;
    });

    this.restService.getOptions(symbol).subscribe((v) => {
      this.QuoteDataOptions = v as AmeritradeOptionQuoteResponse[];
    });

    this.restService.getStocks().subscribe((v) => {
      let values = Object.values(v);
      let symbol_quote = values.find((x) => x.symbol == symbol);
      this.underlying = symbol_quote.lastPrice;
      this.volatillity = symbol_quote.volatility;
    });

    this.displayData = true;

    this.datefilter = symbol;

    this.underlying = 0;
    this.volatillity = 0;

    this.dateNow = formatDate(new Date(), "yyyy-MM-dd", "en-US");
  }

  print() {
    window.print();
    location.reload();
  }

  changeToFixed(value: number, round = 2) {
    const dec = value.toString().split(".")[1];
    const len = dec && dec.length > 0 ? round : 0;
    try {
      return value.toFixed(len);
    } catch (error) {
      console.error("Cannot change to fixed value: " + value);
      return 0;
    }
  }

  formatDate(date: string) {
    var d = new Date(date);
    var m = moment(d);
    return m.format("MM/DD/YYYY");
  }
}
